import { List } from 'immutable';
export default List(['US/Aleutian', 'US/Alaska', 'US/Arizona', 'US/Hawaii', 'US/Samoa', 'US/Indiana-Starke', 'Canada/East-Saskatchewan', 'Europe/Kyiv']);